import React, { useContext, useEffect, useState } from "react";
import { Avatar, Button, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import MainContainer from "../../components/MainContainer";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
  shell: { flex: 1, overflowY: "auto", padding: theme.spacing(1, 3, 4), background: theme.palette.background.paper, borderRadius: "18px 0 0 0", boxShadow: "none", [theme.breakpoints.down("sm")]: { borderRadius: 0, padding: theme.spacing(1, 2, 3) } },
  header: { marginBottom: theme.spacing(3) },
  title: { fontWeight: 600, fontSize: "1.35rem" },
  help: { color: theme.palette.text.secondary, marginTop: 4 },
  form: { maxWidth: 760, display: "flex", flexDirection: "column", gap: theme.spacing(2) },
  avatarRow: { display: "flex", alignItems: "center", gap: theme.spacing(2), paddingBottom: theme.spacing(1) },
  avatar: { width: 72, height: 72 },
  grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: theme.spacing(2), [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" } },
  actions: { display: "flex", justifyContent: "flex-end", marginTop: theme.spacing(1) },
  save: { borderRadius: 999, textTransform: "none", boxShadow: "none" }
}));

const MyProfile = () => {
  const classes = useStyles();
  const { user: sessionUser } = useContext(AuthContext);
  const [form, setForm] = useState({ name: "", email: "", password: "", language: "pt-BR", ticketOrder: "oldest_first" });
  const [preview, setPreview] = useState("");
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!sessionUser?.id) return;
    api.get(`/users/${sessionUser.id}`).then(({ data }) => {
      setForm({ name: data.name || "", email: data.email || "", password: "", language: data.language || "pt-BR", ticketOrder: data.ticketOrder || "oldest_first" });
      setPreview(data.profilePicUrl || "");
    }).catch(toastError);
  }, [sessionUser?.id]);

  const change = event => {
    const { name, value } = event.target;
    setForm(current => ({ ...current, [name]: value }));
  };
  const save = async event => {
    event.preventDefault();
    setSaving(true);
    try {
      const payload = new FormData();
      Object.entries(form).forEach(([key, value]) => { if (key !== "password" || value) payload.append(key, value); });
      if (file) payload.append("profilePic", file);
      await api.put(`/users/${sessionUser.id}`, payload);
      setForm(current => ({ ...current, password: "" }));
      toast.success(i18n.t("myProfile.success"));
    } catch (err) { toastError(err); } finally { setSaving(false); }
  };

  return <MainContainer><div className={classes.shell}>
    <div className={classes.header}><Typography className={classes.title}>{i18n.t("myProfile.title")}</Typography><Typography className={classes.help}>{i18n.t("myProfile.description")}</Typography></div>
    <form className={classes.form} onSubmit={save}>
      <div className={classes.avatarRow}><Avatar src={preview} className={classes.avatar} /><div><input hidden id="my-profile-photo" type="file" accept="image/png,image/jpeg,image/webp" onChange={e => { const next = e.target.files?.[0]; if (next) { setFile(next); setPreview(URL.createObjectURL(next)); } }} /><label htmlFor="my-profile-photo"><Button component="span" variant="outlined">{i18n.t("myProfile.changePhoto")}</Button></label><Typography variant="caption" display="block">{i18n.t("myProfile.photoHelp")}</Typography></div></div>
      <div className={classes.grid}><TextField name="name" value={form.name} onChange={change} label={i18n.t("myProfile.name")} variant="outlined" required fullWidth /><TextField name="email" value={form.email} onChange={change} label={i18n.t("myProfile.email")} type="email" variant="outlined" required fullWidth /></div>
      <TextField name="password" value={form.password} onChange={change} label={i18n.t("myProfile.password")} helperText={i18n.t("myProfile.passwordHelp")} type="password" autoComplete="new-password" variant="outlined" fullWidth />
      <div className={classes.grid}><TextField select SelectProps={{ native: true }} name="language" value={form.language} onChange={change} label={i18n.t("myProfile.language")} variant="outlined"><option value="pt-BR">Português</option><option value="en">English</option><option value="es">Español</option></TextField><TextField select SelectProps={{ native: true }} name="ticketOrder" value={form.ticketOrder} onChange={change} label={i18n.t("myProfile.ticketOrder")} variant="outlined"><option value="oldest_first">{i18n.t("myProfile.oldestFirst")}</option><option value="newest_first">{i18n.t("myProfile.newestFirst")}</option></TextField></div>
      <div className={classes.actions}><Button className={classes.save} disableElevation variant="contained" color="primary" type="submit" disabled={saving}>{saving ? i18n.t("myProfile.saving") : i18n.t("myProfile.save")}</Button></div>
    </form>
  </div></MainContainer>;
};

export default MyProfile;
